import React, { useState } from "react";
import colors from "../../../../theme";
import { AddCardToken } from "../../../../services/api";
import SnackbarComp from "../../../../components/Snackbar/SnackbarComp";

import {
  Grid,
  Box,
  Button,
  Typography,
  Card,
  CardContent,
  CircularProgress,
} from "@mui/material";

import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { useDispatch } from "react-redux";
import { setCardBeingCharged } from "../../../../store/cardChargedSlice";

const AddCardForm = ({ onAddCard }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const dispatch = useDispatch();

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) {
      return;
    }
    setIsLoading(true);
    const { token, error } = await stripe.createToken(
      elements.getElement(CardNumberElement)
    );

    if (error) {
      setErrorMessage(error.message);
      setIsLoading(false);
    } else {
      try {
        const response = await AddCardToken(token.id);
        if (response.status === 201) {
          setError("Card Added Successfully");
          setStatusCode(response?.status || 500);
          setOpenSnackbar(true);
          dispatch(setCardBeingCharged(true));
          onAddCard();

          elements.getElement(CardNumberElement).clear();
          elements.getElement(CardExpiryElement).clear();
          elements.getElement(CardCvcElement).clear();
        }
      } catch (apiError) {
        setErrorMessage("Failed to process token.");
      }

      setIsLoading(false);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleCardChange = () => {
    if (errorMessage) {
      setErrorMessage("");
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Card
          sx={{
            backgroundColor: colors.mainContentBgColor,
            borderRadius: 2,
            width: "100%",
            maxWidth: 400,
            overflow: "visible",
          }}
        >
          <CardContent>
            <Typography
              variant="h6"
              sx={{
                marginBottom: 2,
                textAlign: "center",
                color: colors.primary,
              }}
            >
              Add Card
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box
                  sx={{
                    border: "1px solid gray",
                    borderRadius: "10px",
                    padding: "10px",
                    margin: "4px 0",
                  }}
                >
                  <CardNumberElement
                    options={{
                      showIcon: true,
                      style: {
                        base: {
                          fontSize: "16px",
                          "::placeholder": {
                            content: "xxxx xxxx xxxx xxxx",
                          },
                        },
                        invalid: {
                          color: colors.error,
                        },
                      },
                    }}
                    onChange={handleCardChange}
                  />
                </Box>
              </Grid>

              <Grid item xs={6}>
                <Box
                  sx={{
                    border: "1px solid gray",
                    borderRadius: "10px",
                    padding: "10px",
                    margin: "4px 0",
                  }}
                >
                  <CardCvcElement
                    options={{
                      style: {
                        base: {
                          fontSize: "16px",
                        },
                        invalid: {
                          color: colors.error,
                        },
                      },
                    }}
                    onChange={handleCardChange}
                  />
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box
                  sx={{
                    border: "1px solid gray",
                    borderRadius: "10px",
                    padding: "10px",
                    margin: "4px 0",
                  }}
                >
                  <CardExpiryElement
                    options={{
                      style: {
                        base: {
                          fontSize: "16px",
                        },
                        invalid: {
                          color: colors.error,
                        },
                      },
                    }}
                    onChange={handleCardChange}
                  />
                </Box>
              </Grid>

              <Box
                sx={{
                  padding: "10px 20px",
                  fontSize: "14px",
                  color: "red",
                }}
              >
                {errorMessage && <div>{errorMessage}</div>}
              </Box>
            </Grid>
            <Button
              type="submit"
              variant="contained"
              sx={{
                backgroundColor: colors.secondary,
                "&:hover": {
                  backgroundColor: colors.btnBackgroundColorOnHover,
                },
              }}
              fullWidth
              disabled={!stripe || isLoading}
              onClick={handleSubmit}
            >
              {isLoading ? <CircularProgress size={24} /> : "Add Card"}
            </Button>
          </CardContent>
        </Card>
      </Box>
      <SnackbarComp
        open={openSnackbar}
        onClose={handleCloseSnackbar}
        errorMessage={error}
        statusCode={statusCode}
      />
    </>
  );
};

export default AddCardForm;
